import { render, staticRenderFns } from "./newWaybill.vue?vue&type=template&id=0a0d3b2c&scoped=true"
import script from "./newWaybill.vue?vue&type=script&lang=js"
export * from "./newWaybill.vue?vue&type=script&lang=js"
import style0 from "./newWaybill.vue?vue&type=style&index=0&id=0a0d3b2c&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0d3b2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a0d3b2c')) {
      api.createRecord('0a0d3b2c', component.options)
    } else {
      api.reload('0a0d3b2c', component.options)
    }
    module.hot.accept("./newWaybill.vue?vue&type=template&id=0a0d3b2c&scoped=true", function () {
      api.rerender('0a0d3b2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/waybill/newWaybill/newWaybill.vue"
export default component.exports